import React from "react";
import { /*BsInstagram, BsYoutube,*/ BsLinkedin } from "react-icons/bs";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <a
        href="https://linkedin.com/in/ashleypatricks"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon"
      >
        <div>
          <BsLinkedin />
        </div>
      </a>
      {/* <div>
        <BsInstagram />
      </div>
      <div>
        <BsYoutube />
      </div> */}
      <div style={{ visibility: "hidden" }}></div>
    </div>
  );
};

export default SocialMedia;
